let abc = 'qwertyuiop[]asdfghjkl;zxcvbnm,./1234567890-=';


const getChar = () => abc[Math.round(Math.random()*(abc.length-1))]

export default function(){
    return new Date().getTime()+'-'+getChar()+getChar()+getChar()+getChar()+getChar()+getChar()+getChar();
}